import api from './api';

export const helpRequestService = {
  /**
   * Submit a help request with optional attachments
   * @param {Object} data - Help request data
   * @param {FormData} formData - Form data with files (documents, screenshots, recordings)
   * @returns {Promise} API response
   */
  async createHelpRequest(data, formData = null) {
    // If we have files, use FormData, otherwise use JSON
    if (formData) {
      // Append all help request data to FormData
      Object.keys(data).forEach(key => {
        if (Array.isArray(data[key])) {
          // Handle arrays (e.g., previous_req_ids, to_be_informed_users)
          data[key].forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else if (typeof data[key] === 'object' && data[key] !== null) {
          // Handle nested objects - convert to JSON string
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      });

      const response = await api.post('/api/mobile/help-requests', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // No files, send as JSON
      const response = await api.post('/api/mobile/help-requests', data);
      return response.data;
    }
  },

  /**
   * Get help request options/config (if available)
   */
  async getHelpRequestConfig() {
    try {
      const response = await api.get('/api/mobile/help-requests/config');
      return response.data;
    } catch (error) {
      // Return default config if endpoint doesn't exist
      return {
        modules: ['Documents', 'Processing', 'Alerts', 'Chat', 'Other'],
        issueTypes: ['Technical Issue', 'Bug', 'Performance Issue', 'UI/UX Issue', 'Other'],
        serviceRequestTypes: ['Feature Request', 'Configuration Change', 'Data Update', 'Other'],
        severities: [
          { value: 'low', label: 'Low', color: 'green' },
          { value: 'medium', label: 'Medium', color: 'yellow' },
          { value: 'high', label: 'High', color: 'red' },
        ],
      };
    }
  },

  /**
   * Get list of help requests raised by current user
   */
  async getMyHelpRequests(params = {}) {
    const response = await api.get('/api/mobile/help-requests', { params });
    return response.data;
  },

  /**
   * Get single help request details
   */
  async getHelpRequest(reqId) {
    const response = await api.get(`/api/mobile/help-requests/${reqId}`);
    return response.data;
  },
};
